/**
 * Spanish translations
 */
export default {
  common: {
    loading: 'Cargando...',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    add: 'Agregar',
    close: 'Cerrar',
    confirm: 'Confirmar',
    back: 'Volver',
    next: 'Siguiente',
    yes: 'Sí',
    no: 'No',
    search: 'Buscar',
    filter: 'Filtrar',
    all: 'Todos',
    none: 'Ninguno',
    error: 'Error',
    success: 'Éxito',
    warning: 'Advertencia',
    info: 'Información',
    update: 'Actualizar',
    current: 'actual',
  },
  welcome: {
    title: 'BitTask',
    subtitle: 'Pixel Todo',
    start: 'Iniciar',
    skipForever: 'No mostrar de nuevo',
    version: 'v1.0.0 - Listo sin conexión',
  },
  home: {
    title: 'Tareas',
    newTask: 'Nueva Tarea',
    noTasks: 'Sin tareas todavía',
    addFirstTask: '¡Agrega tu primera tarea!',
    completed: 'Completadas',
    pending: 'Pendientes',
    total: 'Total',
    filterAll: 'Todas',
    filterActive: 'Activas',
    filterCompleted: 'Completadas',
  },
  task: {
    title: 'Título',
    titlePlaceholder: 'Ingresa el título de la tarea',
    titleRequired: 'El título es obligatorio',
    description: 'Descripción',
    descriptionPlaceholder: 'Agrega una descripción (opcional)',
    priority: 'Prioridad',
    priorityLow: 'Baja',
    priorityMedium: 'Media',
    priorityHigh: 'Alta',
    tags: 'Etiquetas',
    tagsPlaceholder: 'Separa las etiquetas con comas',
    completed: 'Completada',
    createdAt: 'Creada el',
    updatedAt: 'Actualizada el',
    deleteConfirm: '¿Eliminar esta tarea?',
    deleteTask: 'Eliminar Tarea',
    deleteTaskConfirm: '¿Estás seguro de que quieres eliminar esta tarea? Esta acción no se puede deshacer.',
    deleteAttachment: 'Eliminar Adjunto',
    deleteAttachmentConfirm: '¿Estás seguro de que quieres eliminar este adjunto? Esta acción no se puede deshacer.',
    attachments: 'Adjuntos',
    noAttachments: 'Sin adjuntos',
    addAttachment: 'Agregar adjunto',
  },
  attachments: {
    title: 'Adjuntos',
    addFile: 'Agregar Archivo',
    addLink: 'Agregar Enlace',
    takePhoto: 'Tomar Foto',
    uploadImage: 'Subir Imagen',
    uploadAudio: 'Subir Audio',
    uploadPdf: 'Subir PDF',
    deleteConfirm: '¿Eliminar este adjunto?',
    previewUnavailable: 'Vista previa no disponible',
    openLink: 'Abrir enlace',
    fileTooBig: 'Archivo muy grande (máximo {{size}})',
    invalidType: 'Tipo de archivo no soportado',
    linkPlaceholder: 'Ingresa o pega una URL',
    addLinkButton: 'Agregar',
  },
  camera: {
    title: 'Cámara',
    capture: 'Capturar',
    retake: 'Repetir',
    usePhoto: 'Usar Foto',
    switchCamera: 'Cambiar Cámara',
    permissionDenied: 'Acceso a la cámara denegado',
    permissionHelp: 'Habilita los permisos de cámara en la configuración del navegador.',
  },
  settings: {
    title: 'Configuración',
    theme: 'Tema',
    themeSlso8: 'SLSO8',
    themeOriginal: 'Original',
    mode: 'Modo',
    modeLight: 'Claro',
    modeDark: 'Oscuro',
    modeSystem: 'Sistema',
    currentMode: 'Actual: {{mode}}',
    language: 'Idioma',
    storage: 'Almacenamiento',
    maxFileSize: 'Tamaño máximo',
    compressImages: 'Comprimir imágenes',
    imageQuality: 'Calidad de imagen',
    appStatus: 'Estado de la App',
    installed: 'Instalada',
    network: 'Red',
    online: 'En línea',
    offline: 'Sin conexión',
    pendingSync: 'Sincronización pendiente',
    operations: 'operaciones',
    installApp: 'Instalar App',
    showWelcome: 'Mostrar pantalla de bienvenida',
    about: 'Acerca de',
    version: 'BitTask v1.0.0',
    aboutDescription: 'Una app PWA de tareas pixel-art con arquitectura offline-first.',
    builtWith: 'Construida con React, TypeScript, Dexie y Vite.',
  },
  errors: {
    generic: 'Algo salió mal',
    networkError: 'Error de conexión',
    notFound: 'No encontrado',
    taskNotFound: 'Tarea no encontrada',
    failedToCreate: 'Error al crear',
    failedToUpdate: 'Error al actualizar',
    failedToDelete: 'Error al eliminar',
    failedToLoad: 'Error al cargar',
  },
  boards: {
    title: 'Tableros',
    manage: 'Gestionar Tableros',
    create: 'Nuevo Tablero',
    rename: 'Renombrar',
    delete: 'Eliminar Tablero',
    deleteConfirm: '¿Estás seguro de que quieres eliminar este tablero? Todas las tareas serán movidas a otro tablero.',
    cannotDeleteLast: 'No se puede eliminar el último tablero',
    transfer: 'Mover a...',
    selectBoard: 'Selecciona un tablero',
    namePlaceholder: 'Nombre del tablero',
    nameRequired: 'El nombre del tablero es obligatorio',
  },
  subtasks: {
    title: 'Lista de tareas',
    add: 'Agregar',
    placeholder: 'Agregar elemento...',
    progress: '{{completed}}/{{total}}',
  },
  share: {
    title: 'Contenido Compartido',
    receivedContent: 'Contenido recibido',
    createTask: 'Crear Nueva Tarea',
    assignToTask: 'Asignar a Tarea Existente',
    dismiss: 'Descartar',
    searchPlaceholder: 'Buscar por #ID o título...',
    untitledTask: 'Elemento Compartido',
    errorReceiving: 'Error al recibir contenido compartido',
    timeout: 'Tiempo de espera agotado',
  },
  speech: {
    start: 'Iniciar entrada de voz',
    stop: 'Detener entrada de voz',
    notSupported: 'Entrada de voz no soportada en este navegador',
  },
} as const;
